import React from "react";

const sportsOptions = [
  "Basketball",
  "Soccer",
  "Football",
  "Baseball",
  "Softball",
  "Tennis",
  "Pickleball",
  "Volleyball",
  "Golf",
  "Swimming",
  "Cycling",
  "Rowing",
  "Boxing",
  "Martial arts",
  "Wrestling",
  "CrossFit",
  "Running",
  "Trail running",
  "Hiking",
  "Rock climbing",
  "Dancing",
  "Skateboarding",
  "Surfing",
  "Skiing (alpine)",
  "Skiing (cross-country)",
  "Snowboarding",
  "Ice skating",
  "Hockey",
  "Sledding",
  "Snowshoeing",
  "Rugby",
  "Lacrosse",
  "Field hockey",
  "Gymnastics",
  "Yoga",
  "Pilates",
];

const createSession = () => ({
  id: `sport-${Date.now()}-${Math.random().toString(16).slice(2)}`,
  activity: "",
  sessionsPerWeek: "",
  duration: "",
  intensity: "",
  isOpen: true,
});

export default function SportsList({ sessions, setSessions }) {
  const hasSessions = sessions.length > 0;

  const addSession = () =>
    setSessions((prev) => [...prev, createSession()]);

  const removeSession = (id) =>
    setSessions((prev) => prev.filter((item) => item.id !== id));

  const updateSession = (id, updates) =>
    setSessions((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, ...updates } : item
      )
    );

  const toggleOpen = (id) =>
    setSessions((prev) =>
      prev.map((item) =>
        item.id === id
          ? { ...item, isOpen: !item.isOpen }
          : item
      )
    );

  return (
    <div className="glass-card p-6">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h3 className="text-lg font-display text-[var(--ink)]">
            Sports & activities
          </h3>
          <p className="text-sm text-[var(--muted)]">
            Optional logs for organized sports and seasonal activities.
          </p>
        </div>
      </div>

      <div className="mt-3 flex flex-wrap gap-2 text-xs">
        <span
          className={`rounded-full px-3 py-1 ${
            hasSessions
              ? "bg-white/80 text-[var(--ink)]"
              : "bg-white/60 text-[var(--muted)]"
          }`}
        >
          {hasSessions ? "Activities logged" : "Optional activity log"}
        </span>
      </div>

      <div className="mt-4 space-y-3">
        {sessions.map((session, index) => (
          <div
            key={session.id}
            className="rounded-2xl border border-white/70 bg-white/70"
          >
            <div className="session-row flex items-center justify-between gap-3 px-4 py-3">
              <button
                type="button"
                onClick={() => toggleOpen(session.id)}
                className="flex items-center gap-3 text-left"
              >
                <span className="text-sm font-semibold text-[var(--ink)]">
                  Activity {index + 1}
                </span>
                <span className="text-xs text-[var(--muted)]">
                  {session.activity || "Select sport"}
                </span>
              </button>
              <button
                type="button"
                onClick={() => removeSession(session.id)}
                className="session-row__remove text-xs text-[var(--accent)] hover:underline"
              >
                Remove
              </button>
            </div>

            <div
              className={`grid gap-4 overflow-hidden px-4 transition-all duration-500 ${
                session.isOpen
                  ? "max-h-[520px] pb-4 opacity-100"
                  : "max-h-0 opacity-0"
              }`}
            >
              <div className="grid gap-3 md:grid-cols-2">
                <label className="text-xs text-[var(--muted)]">
                  Activity type
                  <select
                    className="select-field mt-1"
                    value={session.activity}
                    onChange={(event) =>
                      updateSession(session.id, {
                        activity: event.target.value,
                      })
                    }
                  >
                    <option value="">Select activity</option>
                    {sportsOptions.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </label>
                <label className="text-xs text-[var(--muted)]">
                  Duration per session (minutes)
                  <input
                    type="number"
                    min="0"
                    className="input-field mt-1"
                    value={session.duration}
                    onChange={(event) =>
                      updateSession(session.id, {
                        duration: event.target.value,
                      })
                    }
                  />
                </label>
              </div>

              <div className="grid gap-3 md:grid-cols-2">
                <label className="text-xs text-[var(--muted)]">
                  Sessions per week
                  <input
                    type="number"
                    min="0"
                    max="7"
                    className="input-field mt-1"
                    value={session.sessionsPerWeek}
                    onChange={(event) =>
                      updateSession(session.id, {
                        sessionsPerWeek: event.target.value,
                      })
                    }
                  />
                </label>
                <label className="text-xs text-[var(--muted)]">
                  Intensity (optional)
                  <select
                    className="select-field mt-1"
                    value={session.intensity}
                    onChange={(event) =>
                      updateSession(session.id, {
                        intensity: event.target.value,
                      })
                    }
                  >
                    <option value="">Select intensity</option>
                    <option value="light">Light</option>
                    <option value="moderate">Moderate</option>
                    <option value="hard">Hard</option>
                  </select>
                </label>
              </div>
            </div>
          </div>
        ))}
      </div>

      <button
        type="button"
        onClick={addSession}
        className="mt-4 inline-flex items-center justify-center rounded-full border border-white/70 bg-white/80 px-4 py-2 text-sm font-semibold text-[var(--ink)] transition hover:-translate-y-0.5 hover:shadow-lg"
      >
        Add sport or activity
      </button>
    </div>
  );
}
